import React, { memo } from 'react'

import { HiOutlineSquares2X2 } from 'react-icons/hi2'
import { twMerge } from 'tailwind-merge'

import { OrgDisplay } from '@/components/pursuits/dashboard/ui/OrgBadge'

import type { Organization } from '@/types/Organization'

export const ORG_SELECTOR_TRIGGER_CLASSNAME =
  'inline-flex items-center gap-1.5 h-7 pl-1 pr-1.5 rounded-md border border-primary-300 dark:border-primary-700 bg-white dark:bg-transparent hover:bg-primary-50 dark:hover:bg-primary-800/40 transition-colors max-w-[260px]'

export const ORG_SELECTOR_CONTENT_CLASSNAME = 'p-0 w-72'

export const ORG_SELECTOR_SEARCH_PLACEHOLDER = 'Search organizations...'

export const ORG_SELECTOR_ALL_ITEM_CLASSNAME =
  "text-[13px] cursor-pointer rounded-none hover:!bg-primary-100 dark:hover:!bg-primary-800/40 data-[selected=true]:!bg-primary-100 data-[selected='true']:!bg-primary-100 dark:data-[selected=true]:!bg-primary-800/40 dark:data-[selected='true']:!bg-primary-800/40"

interface AllOrganizationsIconProps {
  className?: string
}

export const AllOrganizationsIcon: React.FC<AllOrganizationsIconProps> = memo(
  ({ className }) => (
    <HiOutlineSquares2X2
      className={twMerge(
        'w-[18px] h-[18px] shrink-0 text-primary-900 dark:text-primary-200',
        className,
      )}
    />
  ),
)

AllOrganizationsIcon.displayName = 'AllOrganizationsIcon'

interface AllOrganizationsRowProps {
  className?: string
  count?: number
  label?: string
}

export const AllOrganizationsRow: React.FC<AllOrganizationsRowProps> = memo(
  ({ className, count, label }) => (
    <span
      className={twMerge(
        'inline-flex items-center gap-1.5 min-w-0 flex-1',
        className,
      )}
    >
      <AllOrganizationsIcon />
      <span className="truncate text-[13px] font-medium text-primary-700 dark:text-primary-200">
        {label ?? `All organizations${count != null ? ` (${count})` : ''}`}
      </span>
    </span>
  ),
)

AllOrganizationsRow.displayName = 'AllOrganizationsRow'

interface OrgMenuRowProps {
  organization: Organization
  className?: string
  muted?: boolean
  trailing?: React.ReactNode
}

export const OrgMenuRow: React.FC<OrgMenuRowProps> = memo(
  ({ organization, className, muted = false, trailing }) => (
    <span
      className={twMerge(
        'inline-flex items-center gap-1.5 min-w-0 flex-1',
        className,
      )}
    >
      <OrgDisplay organization={organization} variant="menu" muted={muted} />
      {trailing}
    </span>
  ),
)

OrgMenuRow.displayName = 'OrgMenuRow'
